import React from "react";
import classNames from "classnames";

import { UseCases } from "@planzone/core";
import { Safeguard } from "@scenes/safeguard";
import { VisibilitySwitch } from "@common/visibilitySwitch";
import { ActivityWatcher } from "@common/activityWatcher";
import { ElementCreationForm } from "@common/elementCreationForm";
import { ElementTypes } from "@common/elementCreationForm/types";
import { Props } from "./types";
import styles from "./styles.scss";

function QuickCreationMenuWrapper({
  project,
  parentList,
  children,
  loader,
  range,
  isThick,
  toggle,
  isInactive,
  defaultType = ElementTypes.TASK,
  isAddingIn,
  setIsAddingIn,
}: Props) {
  const [isOpen, setIsOpen] = React.useState(false);
  const isVisible = isOpen;
  const hide = () => setIsOpen(() => false);
  const show = () => setIsOpen(() => true);

  return (
    <Safeguard
      useCases={[
        UseCases.createTask,
        UseCases.createList,
        UseCases.createMilestone,
        UseCases.createEvent,
      ]}
    >
      {(permissions) => {
        const unAuthorized = !Object.values(permissions).some((flag) => flag);

        return (
          <ActivityWatcher
            className={styles.quickCreationMenuWrapper}
            blur={() => {
              hide();
              toggle && isVisible && toggle(false);
            }}
          >
            <div
              className={classNames(styles.wrapper, {
                [styles.thick]: isThick,
              })}
            >
              {children}
              {!isInactive && !unAuthorized && (
                <VisibilitySwitch
                  renderChildren={(isActionVisible, showAction, hideAction) => (
                    <div
                      className={classNames(styles.actions, {
                        [styles.formVisible]: isVisible,
                      })}
                      onMouseEnter={
                        !isInactive && !unAuthorized ? showAction : undefined
                      }
                      onMouseLeave={
                        !isInactive && !unAuthorized ? hideAction : undefined
                      }
                      onClick={() => {
                        if (isVisible) {
                          hide();
                          toggle && toggle(false);
                          setIsAddingIn && setIsAddingIn(null);
                        } else {
                          show();
                          toggle && toggle(true);
                          setIsAddingIn && setIsAddingIn(null);
                        }
                      }}
                    >
                      {(isActionVisible || isVisible) && (
                        <div className={styles.action}>
                          <div className={styles.addMenu}>
                            <p className={styles.addIcon}>+</p>
                          </div>
                        </div>
                      )}
                    </div>
                  )}
                />
              )}
            </div>
            {((!unAuthorized && isVisible) || isAddingIn) && (
              <div className={styles.elementCreationForm}>
                <ElementCreationForm
                  project={project}
                  parentList={parentList}
                  loader={loader}
                  range={range}
                  defaultType={defaultType}
                  done={() => {
                    hide();
                    toggle && toggle(false);
                    setIsAddingIn && setIsAddingIn(null);
                  }}
                />
              </div>
            )}
          </ActivityWatcher>
        );
      }}
    </Safeguard>
  );
}

export { QuickCreationMenuWrapper };
